
const getTargetDate = ({dateString, hour, minute}) => {
    // Şu anki tarih ve saat
    const now = new Date();

    // Verilen tarih ve saat ile bir tarih nesnesi oluştur
    const futureDate = new Date(dateString);
    futureDate.setHours(hour);
    futureDate.setMinutes(minute);

    // Eğer verilen tarih şu anki tarihten küçük veya eşitse hata döndür
    if (futureDate <= now) {
        return null
    }

    // Yıl, ay, gün, saat, dakika, saniye ve milisaniyeleri sıfır doldur
    const year = futureDate.getFullYear();
    const month = (futureDate.getMonth() + 1).toString().padStart(2, '0'); // Aylar 0 tabanlıdır
    const date = futureDate.getDate().toString().padStart(2, '0');
    const formattedHour = futureDate.getHours().toString().padStart(2, '0');
    const formattedMinute = futureDate.getMinutes().toString().padStart(2, '0');

    // İstenen formatta tarihi döndür
    return `${year}-${month}-${date}T${formattedHour}:${formattedMinute}:00.000`;
}

export default getTargetDate